import React from "react";

import usePageSeo from "../hooks/usePageSeo";
const PrivacyPolicy = () => {
  usePageSeo({
    title: "Privacy Policy | FMart Korea",
    description: "How FMart Korea collects, uses and protects your personal information when you shop for halal groceries on our site.",
  });

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Privacy Policy - FMartKorea</h1>

      <section className="mb-5">
        <p className="text-muted">
          FMartKorea (hereinafter referred to as “the Company”) values your privacy and adheres to relevant data protection laws,
          including the “Act on Protection of Information and Promotion of Utilization of Information and Communications Network.”
          This policy explains how we collect, use, store, and protect your personal data.
        </p>
      </section>

      <section className="mb-5">
        <h4>1. Information We Collect</h4>
        <p className="text-muted">We collect the following information when you interact with our site:</p>
        <ul className="text-muted">
          <li>Name, email, phone number (during account registration)</li>
          <li>Address (for delivery purposes)</li>
          {/* <li>Login data, cookies, IP address, browser/device information (automatically collected)</li> */}
        </ul>
      </section>

      <section className="mb-5">
        <h4>2. How We Collect Data</h4>
        <p className="text-muted">
          Personal data may be collected via our website forms, email, direct inquiries, event participation,
          delivery requests, or automated systems like cookies and logs.
        </p>
      </section>

      <section className="mb-5">
        <h4>3. Use of Personal Information</h4>
        <ul className="text-muted">
          <li>To manage user membership and authentication</li>
          <li>To process and deliver product orders</li>
          <li>To resolve user complaints and inquiries</li>
          <li>To provide updates, promotions, or service notices</li>
          <li>To analyze usage behavior for service improvement</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>4. Data Retention</h4>
        <p className="text-muted">
          Personal data is retained only as long as necessary to fulfill its original purpose. After that, it is securely discarded unless required
          by law to be kept for a longer period. Examples:
        </p>
        <ul className="text-muted">
          <li>Records of contracts: 5 years</li>
          <li>Consumer complaints: 3 years</li>
          <li>Access logs: 3 months</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>5. Disposal of Personal Data</h4>
        <p className="text-muted">
          Once personal data has fulfilled its purpose, it will be moved to a separate database and securely deleted to prevent reuse or access.
        </p>
      </section>

      <section className="mb-5">
        <h4>6. Sharing of Information</h4>
        <p className="text-muted">
          Your personal data is never shared with third parties except in the following cases:
        </p>
        <ul className="text-muted">
          <li>With your prior consent</li>
          <li>Required by law or governmental authorities</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>7. Use of Cookies</h4>
        <p className="text-muted">
          FMartKorea uses cookies to understand visitor behavior and improve the user experience. You can configure your browser to accept or reject cookies as you prefer.
        </p>
      </section>

      <section className="mb-5">
        <h4>8. Your Rights</h4>
        <ul className="text-muted">
          <li>View and edit your personal data</li>
          <li>Request account deletion or termination</li>
          <li>Request correction of inaccurate data</li>
          <li>File privacy-related complaints via our contact information</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>9. Privacy Inquiries</h4>
        <p className="text-muted">
          For privacy-related inquiries, complaints, or concerns, please contact:
        </p>
        <ul className="text-muted">
          <li><strong>Customer Support:</strong> +82-10-9603-7214</li>
          <li><strong>Email:</strong> admin@fmartskorea.com</li>
        </ul>
        <p className="text-muted">
          You may also contact the following agencies for external help:
        </p>
        <ul className="text-muted">
          <li>Privacy Rights Violation Center: privacy.kisa.or.kr / 118</li>
          <li>Cybercrime Investigation (Supreme Prosecutor’s Office): www.spo.go.kr / 02-3480-2000</li>
          <li>Cyber Bureau (National Police Agency): www.ctrc.go.kr / 182</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>10. Policy Updates</h4>
        <p className="text-muted">
          FMartKorea reserves the right to update this policy. Changes will be posted on this page.  
        </p>
        <p className="text-muted"><strong>Effective Date:</strong> 2025-07-23</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
